import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import {
  Button,
  ButtonProps,
  DesignToken,
  Heading,
  Icon,
  IconSource,
  SpacingToken,
  THeadingSize,
  Text,
} from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  title: string | { text: string; size?: THeadingSize };
  description: string | ReactNode;
  primaryAction: {
    label: string;
    onClick: () => void;
    kind?: ButtonProps["kind"];
    disabled?: boolean;
    testId?: string;
  };
  icon?: IconSource;
  templates?: ReactNode;
  contentWidth?: number;
  className?: string;
}
export const AutomationsEmptyState: FC<IProps> = ({
  title,
  description,
  primaryAction: { label, onClick, kind = "primary", disabled = false, testId },
  icon,
  templates,
  contentWidth = 568,
  className,
}) => {
  const isTitleStringType = typeof title === "string";

  return (
    <Wrapper className={className}>
      <Content width={contentWidth}>
        {icon && <Icon source={icon} size="xxxlarge" />}
        <Heading size={isTitleStringType ? undefined : title.size}>{isTitleStringType ? title : title.text}</Heading>
        <Text>{description}</Text>
        <Button kind={kind} onClick={onClick} disabled={disabled} data-testid={testId}>
          {label}
        </Button>
      </Content>
      {templates && (
        <Templates>
          <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
            Or select one of the ready-made templates
          </Text>
          {templates}
        </Templates>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${withVar(SpacingToken.Spacing8)};
  align-items: center;

  max-width: 100%;
  align-self: center;
  padding: ${withVar(SpacingToken.Spacing4)};
  padding-bottom: ${withVar(SpacingToken.Spacing8)};
`;

const Content = styled.div<{ width: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing4)};

  text-align: center;
  padding-bottom: ${withVar(SpacingToken.Spacing4)};
  width: ${({ width }): number => width}px;
`;

const Templates = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing4)};

  max-width: 100%;
`;
